module.exports = __webpack_public_path__ + "img/Group-5030.dc2659f7.svg";